












import { Component, Vue, Prop } from 'vue-property-decorator'
import { Company, FinanceInfo, InvestmentStatusReport } from '@/utils/Interfaces'
import BaoCaoGeneric from '@/components/BaoCaoGeneric.vue'

declare interface FormattedReport extends InvestmentStatusReport {
  company: Company['name'];
  von_gop_ke_hoach: InvestmentStatusReport['von_gop_ke_hoach'];
  von_gop_nam_truoc: InvestmentStatusReport['von_gop_nam_truoc'];
  von_gop_nam_nay: InvestmentStatusReport['von_gop_nam_nay'];
  ty_le_von_gop_ke_hoach: InvestmentStatusReport['ty_le_von_gop_ke_hoach'];
  ty_le_von_gop_nam_truoc: InvestmentStatusReport['ty_le_von_gop_nam_truoc'];
  ty_le_von_gop_nam_nay: InvestmentStatusReport['ty_le_von_gop_nam_nay'];
  von_dieu_le: InvestmentStatusReport['von_dieu_le'];
  von_chu_so_huu: InvestmentStatusReport['von_chu_so_huu'];
  doanh_thu_ky_truoc: InvestmentStatusReport['doanh_thu_ky_truoc'];
  doanh_thu_ky_bao_cao: InvestmentStatusReport['doanh_thu_ky_bao_cao'];
  loi_nhuan_ky_truoc: InvestmentStatusReport['loi_nhuan_ky_truoc'];
  loi_nhuan_ky_bao_cao: InvestmentStatusReport['loi_nhuan_ky_bao_cao'];
  loi_nhuan_chia: InvestmentStatusReport['loi_nhuan_chia'];
  ty_le_loi_nhuan_chia_tren_von_dau_tu: InvestmentStatusReport['ty_le_loi_nhuan_chia_tren_von_dau_tu'];
  he_so_kha_nang_thanh_toan_no_den_han: InvestmentStatusReport['he_so_kha_nang_thanh_toan_no_den_han'];
  he_so_no_tren_von_chu_so_huu: InvestmentStatusReport['he_so_no_tren_von_chu_so_huu'];
}


@Component({
  components: {
    BaoCaoGeneric,
  }
})
export default class BaoCaoTinhHinhDauTu extends Vue {
  @Prop(Array) readonly reports!: Array<InvestmentStatusReport>

  reportType = 'BaoCaoTinhHinhDauTu'

  headerMapper: { [index: string]: string } = {
    company: 'Công ty',
    von_gop_ke_hoach: 'Giá trị vốn góp kế hoạch',
    von_gop_nam_truoc: 'Giá trị vốn góp năm trước',
    von_gop_nam_nay: 'Giá trị vốn góp năm nay',
    ty_le_von_gop_ke_hoach: 'Tỷ lệ giá trị vốn góp kế hoạch',
    ty_le_von_gop_nam_truoc: 'Tỷ lệ giá trị vốn góp năm trước',
    ty_le_von_gop_nam_nay: 'Tỷ lệ giá trị vốn góp năm nay',
    von_dieu_le: 'Vốn điều lệ',
    von_chu_so_huu: 'Vốn chủ sở hữu',
    doanh_thu_ky_truoc: 'Doanh thu kỳ trước',
    doanh_thu_ky_bao_cao: 'Doanh thu kỳ báo cáo',
    loi_nhuan_ky_truoc: 'Lợi nhuận sau thuế kỳ trước',
    loi_nhuan_ky_bao_cao: 'Lợi nhuận sau thuế kỳ báo cáo',
    loi_nhuan_chia: 'Cổ tức hoặc lợi nhuận được chia năm báo cáo',
    ty_le_loi_nhuan_chia_tren_von_dau_tu: 'Tỷ lệ lợi nhuận được chia trên vốn đầu tư',
    he_so_kha_nang_thanh_toan_no_den_han: 'Hệ số khả năng thanh toán nợ đến hạn',
    he_so_no_tren_von_chu_so_huu: 'Hệ số nợ trên vốn chủ sở hữu',
  }

  formatMapper: { [index: string]: string | null } = {
    company: 'link',
    von_gop_ke_hoach: 'money',
    von_gop_nam_truoc: 'money',
    von_gop_nam_nay: 'money',
    ty_le_von_gop_ke_hoach: 'percentage',
    ty_le_von_gop_nam_truoc: 'percentage',
    ty_le_von_gop_nam_nay: 'percentage',
    von_dieu_le: 'money',
    von_chu_so_huu: 'money',
    doanh_thu_ky_truoc: 'money',
    doanh_thu_ky_bao_cao: 'money',
    loi_nhuan_ky_truoc: 'money',
    loi_nhuan_ky_bao_cao: 'money',
    loi_nhuan_chia: 'money',
    ty_le_loi_nhuan_chia_tren_von_dau_tu: 'percentage',
    he_so_kha_nang_thanh_toan_no_den_han: 'number',
    he_so_no_tren_von_chu_so_huu: 'number',
  }

  choicesMapper: { [index: string]: unknown } = {}

  get formattedReports () {
    const formattedReports: Array<FormattedReport> = []

    this.reports.forEach(report => {
      // @ts-expect-error
      const formattedReport: FormattedReport = {}

      // Get company name
      const financeInfo = report.finance_info as FinanceInfo
      const company = financeInfo.company as Company
      const companyName = company.name
      formattedReport.company = companyName

      // Get remaining info
      Object.assign(formattedReport, report)
      // Remove not needed info
      delete formattedReport.finance_info
      delete formattedReport.created_at
      delete formattedReport.updated_at

      formattedReports.push(formattedReport)
    })

    return formattedReports
  }
}
